import axios from "../../config/axiosConfig";
import {
    GET_FINYEAR_COMPANIES,
    GET_FINYEAR_USERS,
    FINYEAR_COMPANY_REQUEST,
    FINYEAR_COMPANY_REQUEST_FAILURE,
} from "../types";

export const getLinkedFinyearCompanies = () => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: FINYEAR_COMPANY_REQUEST });
            const { auth } = getState();
            let params = { userId: auth.customer?.User_Id };
            return axios.get("/linkFinyearCompany/getAll", { params }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_FINYEAR_COMPANIES, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: FINYEAR_COMPANY_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FINYEAR_COMPANY_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const getLinkedFinyearUsers = (finyearId) => {
    return async (dispatch, getState) => {
        try {
            dispatch({ type: FINYEAR_COMPANY_REQUEST });
            return axios.get("/linkFinyearCompany/getAll", { params: { finyearId } }).then((response) => {
                if (response.data) {
                    dispatch({ type: GET_FINYEAR_USERS, payload: response.data });
                }
            }).catch((error) => {
                console.error(error);
                dispatch({ type: FINYEAR_COMPANY_REQUEST_FAILURE, error: error.message });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FINYEAR_COMPANY_REQUEST_FAILURE, error: error.message });
        }
    };
};

export const linkFinyearUsers = (data) => {
    return async (dispatch) => {
        try {
            dispatch({ type: FINYEAR_COMPANY_REQUEST });
            data.forEach(async (val) => {
                await axios.put(`/linkFinyearCompany/link-customer`, { ...val });
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FINYEAR_COMPANY_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};

export const unlinkFinyearUsers = (ids) => {
    return async (dispatch) => {
        try {
            dispatch({ type: FINYEAR_COMPANY_REQUEST });
            ids.forEach(async (id) => {
                await axios.delete(`/linkFinyearCompany/delete/${id}`);
            });
        } catch (error) {
            console.error(error);
            dispatch({ type: FINYEAR_COMPANY_REQUEST_FAILURE, error: error.message });
            throw error;
        }
    };
};